import React, { CSSProperties } from 'react';
import TextField from '@mui/material/TextField';
import moment from 'moment';
import { InputLabelProps as MuiInputLabelProps } from '@mui/material/InputLabel';
import { TextFieldProps } from '@mui/material/TextField';
import { SxProps } from '@mui/system';

interface DateInputProps {
  fullWidth?: boolean;
  autoFocus?: boolean;
  variant?: 'standard' | 'outlined' | 'filled';
  name?: string;
  label?: string;
  value?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: boolean;
  helperText?: React.ReactNode;
  touched?: boolean;
  errors?: string;
  disabled?: boolean;
  InputLabelProps?: Partial<MuiInputLabelProps>;
  inputProps?: TextFieldProps['inputProps'];
  sx?: SxProps;
  style?: CSSProperties;
}

const formatValue = (dateValue: string | undefined) => {
  // Return empty if no value is passed
  if (!dateValue) {
    return '';
  }

  // If it's not a valid date, keep the current value
  const formattedDate = moment(dateValue, 'YYYY-MM-DD', true).isValid()
    ? moment(dateValue).format('YYYY-MM-DD')
    : dateValue;

  return formattedDate;
};

export const DateInput: React.FC<DateInputProps> = ({
  fullWidth,
  autoFocus,
  variant,
  name,
  label,
  value,
  onChange,
  onBlur,
  onFocus,
  error,
  helperText,
  disabled,
  InputLabelProps,
  inputProps,
  sx,
  style
}) => {
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const dateValue = e.target.value;

    // Check if the year is longer than 4 digits
    const year = dateValue.split('-')[0];
    if (year.length <= 4) {
      onChange(e);
    }
  };

  return (
    <TextField
      fullWidth={fullWidth}
      autoFocus={autoFocus}
      variant={variant}
      name={name}
      label={label}
      type="date"
      InputLabelProps={{ ...InputLabelProps }}
      inputProps={inputProps}
      value={formatValue(value)}
      onChange={handleDateChange}
      onBlur={onBlur}
      onFocus={onFocus}
      error={error}
      helperText={helperText}
      disabled={disabled}
      sx={sx}
      style={style}
    />
  );
};
